import React from "react";
import { TextField, Typography } from "@mui/material";
import "../../styles/TextInput.css";
import { Controller } from "react-hook-form";

const TextInput = ({ children, select, width, height, multiline, control, name, defaultValue, validation, isRequired, ...rest }) => {
  console.log("isRequired", name, isRequired);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={validation}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div>
          <TextField
            sx={{
              ...(width && { minWidth: width }),
              ...(height && { minHeight: height }),
              marginRight: select ? "1rem" : 0,
            }}
            name={name}
            onChange={onChange}
            select={select}
            multiline={multiline}
            value={value || defaultValue || ""}
            minRows={multiline ? 3 : 0}
            maxRows={multiline ? 3 : 0}
            error={!!error}
            required={isRequired}
            // {...validation}
            {...rest}
          >
            {children}
          </TextField>
          {error && (
            <Typography variant="caption" color="error">
              {error.message}
            </Typography>
          )}
        </div>
      )}
    />
  );
};

export default TextInput;
